import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger } from '@org/ui';
import { AnalyticsProvider, useAnalytics } from './analytics-context';
import { AnalyticsFilterBar } from './analytics-filter-bar';
import { CATEGORIES, type Category } from './filters';
import { OverviewReports } from './categories/overview-reports';
import { RetentionReports } from './categories/retention-reports';
import { RiskReports } from './categories/risk-reports';
import { LearningReports } from './categories/learning-reports';
import { AttendanceReports } from './categories/attendance-reports';
import { ChatReports } from './categories/chat-reports';
import { FeedbackReports } from './categories/feedback-reports';
import { JourneyReports } from './categories/journey-reports';

const CATEGORY_COMPONENTS: Record<Category, () => JSX.Element> = {
  overview: OverviewReports,
  retention: RetentionReports,
  risk: RiskReports,
  learning: LearningReports,
  attendance: AttendanceReports,
  chat: ChatReports,
  feedback: FeedbackReports,
  journey: JourneyReports,
};

function AnalyticsPageInner() {
  const { t } = useTranslation('admin');
  const { search, update } = useAnalytics();
  const Reports = CATEGORY_COMPONENTS[search.category];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">{t('analytics.page.title')}</h1>
        <p className="text-sm text-muted-foreground">{t('analytics.page.subtitle')}</p>
      </div>

      <AnalyticsFilterBar />

      <Tabs value={search.category} onValueChange={(v) => update({ category: v as Category, session: undefined })}>
        <TabsList className="flex h-auto w-full flex-wrap justify-start gap-1 bg-transparent p-0">
          {CATEGORIES.map((category) => (
            <TabsTrigger
              key={category}
              value={category}
              className="rounded-full border px-3 py-1.5 text-xs data-[state=active]:border-[#cf2e2e] data-[state=active]:bg-[#cf2e2e] data-[state=active]:text-white"
            >
              {t(`analytics.categories.${category}`)}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      <p className="text-xs text-muted-foreground">{t(`analytics.categoryIntro.${search.category}`)}</p>

      <Reports />
    </div>
  );
}

export function AnalyticsPage() {
  return (
    <AnalyticsProvider>
      <AnalyticsPageInner />
    </AnalyticsProvider>
  );
}
